if (!customElements.get('stories-slider')) {
  customElements.define(
    'stories-slider',
    class StoriesSlider extends HTMLElement {
      connectedCallback() {
        this.videos = Array.from(this.querySelectorAll('video'));
        this.onClick = this.onClick.bind(this);
        this.addEventListener('click', this.onClick);
        this.initSwiper();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        clearInterval(this.swiperPoll);
        if (this.swiper) this.swiper.destroy(true, true);
      }

      // Swiper is injected by the theme's lazy loader, so wait until it exists.
      initSwiper() {
        const container = this.querySelector('.stories-slider__swiper');
        if (!container) return;

        const create = () => {
          if (!window.Swiper || this.swiper) return false;
          this.swiper = new window.Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            watchOverflow: true,
            navigation: {
              prevEl: this.querySelector('.swiper-button-prev'),
              nextEl: this.querySelector('.swiper-button-next'),
            },
            scrollbar: {
              el: this.querySelector('.stories-slider__scrollbar'),
              draggable: true,
            },
            breakpoints: {
              990: { spaceBetween: 30 },
            },
            on: {
              slideChange: () => this.pauseAll(),
            },
          });
          return true;
        };

        if (create()) return;
        this.swiperPoll = setInterval(() => {
          if (create()) clearInterval(this.swiperPoll);
        }, 200);
      }

      onClick(event) {
        const card = event.target.closest('.stories-slider__card');
        if (!card) return;
        const video = card.querySelector('video');
        if (!video) return;

        if (video.paused) {
          this.pauseAll(video);
          video.muted = false;
          video.play();
          card.classList.add('is-playing');
        } else {
          video.pause();
          card.classList.remove('is-playing');
        }
      }

      pauseAll(except) {
        this.videos.forEach((video) => {
          if (video === except) return;
          video.pause();
          video.closest('.stories-slider__card').classList.remove('is-playing');
        });
      }
    }
  );
}
